export const HOME_PAGE_VIEW = 'home_page_view';
export const FLIGHTS_PAGE_VIEW = 'flights_page_view';
export const FLIGHT_SEARCH = 'flight_search';
export const HEADER_LOGIN_BUTTON_CLICK = 'header_login_button_click';
export const CONTACT_US_PAGE_VIEW = 'contactus_page_view';
export const HOTELS_PAGE_VIEW = 'hotels_page_view';
export const HOTEL_SEARCH = 'hotel_search';
